import { Moment } from 'moment'

import { DATE_STORE_KEY_FORMAT } from '../../Common/settings/dateFormats'

export const getDaysBetweenDates = (startDate: Moment, endDate: Moment) => {
  const now = startDate.clone()
  const dates = []

  while (now.isSameOrBefore(endDate)) {
    dates.push(now.format(DATE_STORE_KEY_FORMAT))
    now.add(1, 'days')
  }
  return dates
}
